import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { Provider } from 'react-redux';
import { Redirect, Route, BrowserRouter as Router } from "react-router-dom";

import axios from 'axios';
import initSubscriber from 'redux-subscriber';

// import logo from './logo.svg';
// import './App.css';

import { } from "";
import { httpRequest } from 'plugin/httprequest';
import { getParam } from 'redux/actions/gblparam';
import { showLoading } from "redux/actions/loading";
import axiosException from "./plugin/exceptionmessage";
import { sessionRole, sessionToken, sessionUser } from './redux/actions/session';
//components
import Navbar from './components/headerComponent/navbar';
// import Footer from './components/footerComponent/footer';
import Loading from './components/pages/parts/loading';
import Login from './components/pages/login';

import UserParticipant from 'components/pages/participant/admin/user';
import DecisionMenu from 'components/pages/participant/admin/decisionMenu';
import AutoProses from 'components/pages/participant/admin/autoProses';
import DaftarTugas from 'components/pages/participant/admin/daftarTugas';

import DaftarPesertaAktif from 'components/pages/participant/peserta/daftarPesertaAktif/index';
import RegistrasiPesertaAktif from 'components/pages/participant/peserta/registasiAktif/index';
import ProsesAktifasiAktifDapen from 'components/pages/participant/peserta/aktifasiDapen/index';
import DaftarPesertaPasif from 'components/pages/participant/peserta/daftarPesertaPasif/index';

import PengajuanKlaimPesertaAktif from 'components/pages/participant/klaim/pengajuanKlaimPesertaAktif';
import ProsesKlaimDapen from 'components/pages/participant/klaim/prosesKlaimDapen';
import RiwayatKlaimPesertaAktif from 'components/pages/participant/klaim/riwayatKlaimPesertaAktif';

import IuranBulanan from 'components/pages/participant/iuran/iuranBulanan';
import ProsesIuranDapen from 'components/pages/participant/iuran/prosesIuranDapen';
import RiwayatIuranBulanan from 'components/pages/participant/iuran/riwayatIuranBulanan';

import CreateNewPassword from 'components/pages/createNewPassword';
import TopMenu from 'components/headerComponent/topmenu';
// import Dashboard from 'components/pages/dashboard';
import GlobalParameter from 'components/pages/global-setting/global-parameter/index';
import ProfilePerusahaan from 'components/pages/participant/admin/profilePerusahaan';
import DashboardClient from './components/pages/dashboard/index';
import ReportPesertaAktif from 'components/pages/participant/laporan/kepesertaan/pesertaAktif';
import ReportPesertaPasif from 'components/pages/participant/laporan/kepesertaan/pesertaPasif';
import PengajuanKlaimAktif from 'components/pages/participant/klaim/pengajuanKlaimAktif';
import LaporanIuranBulanan from 'components/pages/participant/laporan/iuran/iuran-bulanan/index';
import LaporanOutstandingIuran from 'components/pages/participant/laporan/iuran/outstanding-iuran.js/index';


class App extends Component {
  constructor(props) {
    super(props)

    this.PropTypes = {
      store: PropTypes.object.isRequired
    }

    this.state = {
      loginStatus: false,
      redirect: '',
      username: '',
      role: [],
      menuActive: '',
      menuArray: []
    }

    this.store = this.props.store;
    this.subscribe = initSubscriber(this.store)
    this.NavbarRef = React.createRef();
    this.TopMenuRef = React.createRef();

    this.headerRef = React.createRef()
  }

  componentDidMount = () => {
    this.subscribe('sessionToken', data => {
      this.checkSession(this.store)
    });

    this.subscribe('urls', data => {
      this.checkSession(this.store)
      // this.setActiveMenu(this.store)
    });

    this.subscribe('sessionRole', data => {
      this.getMenuAccess()
    })

    this.checkSession(this.store)
    // this.setActiveMenu(this.store)

    this.store.dispatch(showLoading(false))

    setTimeout(() => {
      this.getMenuAccess()
    }, 0)
  }

  getMenuAccess = async () => {
    var menu
    if (this.props.store.getState().sessionToken && typeof this.props.store.getState().sessionToken !== 'object') {
      menu = await httpRequest(process.env.REACT_APP_BACKEND, this.props.store, `sys-menu-groups/enabled-multigroup/${this.props.store.getState().sessionRole.join(',')}/true`) || []

      if (menu.length === 0) {
        this.TopMenuRef.current.setTopMenu([])
        this.NavbarRef.current.setSideMenu([])
      }
      var topMenu = menu.filter(value => value.level === 0).map(value => {
        return {
          menuCode: value.menuCode,
          text: value.menuName,
          url: `/${value.linkPage}`
        }
      })
      var sideMenu = menu.filter(value => value.level === 0).map(value => {
        var menuLevel1 = menu.filter(level1 => level1.level === 1 && level1.parentCode === value.menuCode).map(level1 => {
          var menuLevel2 = menu.filter(level2 => level2.level === 2 && level2.parentCode === level1.menuCode)

          if (menuLevel2.length > 0) {
            menuLevel2 = menuLevel2.map(level2 => {
              var menuLevel3 = menu.filter(level3 => level3.level === 3 && level3.parentCode === level2.menuCode)

              if (menuLevel3.length > 0) {
                menuLevel3 = menuLevel3.map(level3 => {
                  return {
                    menuCode: level3.menuCode,
                    text: level3.menuName,
                    url: level3.linkPage,
                  }
                })
                return {
                  menuCode: level2.menuCode,
                  text: level2.menuName,
                  url: level2.linkPage,
                  child: menuLevel3
                }
              } else {
                return {
                  menuCode: level2.menuCode,
                  text: level2.menuName,
                  url: level2.linkPage,
                }
              }
            })

            return {
              menuCode: level1.menuCode,
              text: level1.menuName,
              url: level1.linkPage,
              child: menuLevel2
            }
          } else {
            return {
              menuCode: level1.menuCode,
              text: level1.menuName,
              url: level1.linkPage,
            }
          }
        })

        return {
          menuCode: value.menuCode,
          menuName: value.linkPage,
          menuList: menuLevel1
        }
      })

      this.TopMenuRef.current.setTopMenu(topMenu)
      this.NavbarRef.current.setSideMenu(sideMenu)
    }
  }

  componentDidUpdate = (prevProps, prevState) => {}

  setActiveMenu = (store) => {
    var activeMenus = store.getState().urls.split('/')

    if (activeMenus.length > 1) {
      this.setState({
        menuActive: activeMenus[2],
        topmenuActive: activeMenus[1],
        menuArray: activeMenus
      })
    }
  }

  checkSession = (store) => {
    if (!(store.getState().sessionToken instanceof Array) && store.getState().sessionToken) {
      let token = store.getState().sessionToken;

      axios.get(process.env.REACT_APP_BACKEND + 'authenticate', {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      }).then((response) => {
        if (response.data === '') {
          document.getElementById('app-container').classList.add('d-none')

          confirmAlert({
            title: 'Session Expired',
            message: "Session expired, please re-login!",
            buttons: [
              {
                label: 'Tutup',
                onClick: () => {
                  this.logout()
                }
              },
            ]
          });
        } else {
          var param = this.props.store.getState().getParam
          var systemDate
          if (param ? param.length > 0 : param) {
            systemDate = param.find(value => value.paramCode === '0 SYSDATE')
          }
          systemDate = systemDate ? systemDate.dateValue : null

          if (this.TopMenuRef.current && this.NavbarRef.current) {
            this.TopMenuRef.current.setUsername(response.data)
            this.NavbarRef.current.setSystemDate(systemDate)
          }

          if (document.getElementById('app-container')) {
            document.getElementById('app-container').classList.remove('d-none')
          }

          if (store.getState().urls === '/') {
            this.setState({
              redirect: '/dashboard'
            })
          }


        }

      }).catch((error) => {
        console.log(error)
        document.getElementById('app-container').classList.add('d-none')

        confirmAlert({
          title: 'Connection Lost',
          message: axiosException(error),
          buttons: [
            {
              label: 'Tutup',
              onClick: () => {
                this.logout()
              }
            },
          ]
        });
      })
    } else {
      document.getElementById('app-container').classList.add('d-none')
      if (((this.store.getState().sessionToken instanceof Array) || !this.store.getState().sessionToken) && this.store.getState().urls !== '/' && this.store.getState().urls !== '/createNewPassword') {
        this.setState({
          redirect: '/'
        })
      } else if (((this.store.getState().sessionToken instanceof Array) || !this.store.getState().sessionToken) && this.store.getState().urls === '/createNewPassword') {
        this.setState({
          redirect: '/createNewPassword'
        })
      }
    }
  }

  logout = (e) => {
    if (e) {
      e.preventDefault()
    }

    let store = this.props.store;

    store.dispatch(sessionToken(null));
    store.dispatch(getParam(null));
    store.dispatch(sessionUser(null));
    store.dispatch(sessionRole(null));
    this.setState({
      redirect: '/'
    })
  }

  renderRedirect = () => {
    if (this.state.redirect !== '') {
      return <Redirect to={this.state.redirect} />
    } else {
      return null
    }
  }

  render() {
    return (
      <div className="App dx-swatch-dapen-pegadaian">
        <Loading store={this.props.store} />
        <Provider store={this.props.store}>
          <Router>
            {this.renderRedirect()}
            <Route exact path="/" component={(props) => <Login {...props} store={this.props.store} />} />
            <Route exact path="/createNewPassword" component={(props) => <CreateNewPassword {...props} store={this.props.store} />} />
            <div id="app-container">
              <div className="app hide-sidenav">
                <TopMenu store={this.props.store} ref={this.TopMenuRef} logout={(e) => this.logout(e)} />
                <Navbar store={this.props.store} ref={this.NavbarRef} />

                <article className="content dashboard-page">
                  <section className="section">
                    {/* <Route exact path="/dashboard" component={(props) => <DashboardMonitoringInvestasi {...props} store={this.props.store} />} /> */}
                    <Route exact path="/dashboard" component={(props) => <DashboardClient {...props} store={this.props.store} />} />

                    {/* Participant Menu */}
                    <Route exact path="/participant/admin/user" component={(props) => <UserParticipant {...props} store={this.props.store} />} />
                    <Route exact path="/participant/admin/auto-proses" component={(props) => <AutoProses {...props} store={this.props.store} />} />
                    <Route exact path="/participant/admin/decision-menu" component={(props) => <DecisionMenu {...props} store={this.props.store} />} />
                    <Route exact path="/participant/admin/profile-perusahaan" component={(props) => <ProfilePerusahaan {...props} store={this.props.store} />} />
                    <Route exact path="/participant/admin/daftar-tugas" component={(props) => <DaftarTugas {...props} store={this.props.store} />} />

                    <Route exact path="/participant/peserta/daftar-peserta-aktif" component={(props) => <DaftarPesertaAktif {...props} store={this.props.store} />} />
                    <Route exact path="/participant/peserta/registrasi-peserta-aktif" component={(props) => <RegistrasiPesertaAktif {...props} store={this.props.store} />} />
                    <Route exact path="/participant/peserta/proses-aktivasi-aktif-dapen" component={(props) => <ProsesAktifasiAktifDapen {...props} store={this.props.store} />} />
                    <Route exact path="/participant/peserta/daftar-peserta-pasif" component={(props) => <DaftarPesertaPasif {...props} store={this.props.store} />} />

                    <Route exact path="/participant/klaim/pengajuan-klaim-peserta" component={(props) => <PengajuanKlaimAktif {...props} store={this.props.store} />} />
                    <Route exact path="/participant/klaim/pengajuan-klaim-peserta-aktif" component={(props) => <PengajuanKlaimPesertaAktif {...props} store={this.props.store} />} />
                    <Route exact path="/participant/klaim/proses-klaim-dapen" component={(props) => <ProsesKlaimDapen {...props} store={this.props.store} />} />
                    <Route exact path="/participant/klaim/riwayat-klaim" component={(props) => <RiwayatKlaimPesertaAktif {...props} store={this.props.store} />} />

                    <Route exact path="/participant/iuran/iuran-bulanan" component={(props) => <IuranBulanan {...props} store={this.props.store} />} />
                    <Route exact path="/participant/iuran/proses-iuran-dapen" component={(props) => <ProsesIuranDapen {...props} store={this.props.store} />} />
                    <Route exact path="/participant/iuran/riwayat-iuran-bulanan" component={(props) => <RiwayatIuranBulanan {...props} store={this.props.store} />} />

                    <Route exact path="/participant/laporan/kepesertaan/peserta-aktif" component={(props) => <ReportPesertaAktif {...props} store={this.props.store} />} />
                    <Route exact path="/participant/laporan/kepesertaan/peserta-pensiun" component={(props) => <ReportPesertaPasif {...props} store={this.props.store} />} />

                    <Route exact path="/participant/laporan/iuran/iuran-bulanan" component={(props) => <GlobalParameter {...props} store={this.props.store} />} />
                    <Route exact path="/participant/laporan/iuran/outstanding-iuran" component={(props) => <GlobalParameter {...props} store={this.props.store} />} />
                    <Route exact path="/participant/laporan/iuran/management" component={(props) => <GlobalParameter {...props} store={this.props.store} />} />

                    <Route exact path="/participant/laporan/klaim/klaim-penutupan-akun" component={(props) => <GlobalParameter {...props} store={this.props.store} />} />
                    <Route exact path="/participant/laporan/klaim/klaim-tanpa-penutupan" component={(props) => <GlobalParameter {...props} store={this.props.store} />} />

                    <Route exact path="/participant/laporan/iuran/iuran-bulan" component={(props) => <LaporanIuranBulanan {...props} store={this.props.store} />} />
                    <Route exact path="/participant/laporan/iuran/outstanding-iura" component={(props) => <LaporanOutstandingIuran {...props} store={this.props.store} />} />

                  </section>
                </article>
              </div>
            </div>
            {/* <Footer store={this.props.store}/> */}
          </Router>
        </Provider>

      </div>
    );
  }
}

export default App;